export const saveToken = (token) => localStorage.setItem("authToken", token);
export const getToken = () => localStorage.getItem("authToken");
export const clearToken = () => localStorage.removeItem("authToken");

/**
 * Checks if a JWT token is expired.
 * @param {string} token - Optional token to check. If not provided, it will get the token from storage.
 * @returns {boolean} - True if the token is expired or invalid, false otherwise.
 */
export const isTokenExpired = (token) => {
  const jwtToken = token || getToken();
  if (!jwtToken) return true;

  try {
    // JWT tokens consist of three parts separated by dots
    const parts = jwtToken.split(".");
    if (parts.length !== 3) return true;

    const base64Url = parts[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join(""),
    );

    const { exp } = JSON.parse(jsonPayload);
    if (!exp) return false;

    // exp is in seconds, Date.now() is in milliseconds
    const now = Math.floor(Date.now() / 1000);
    return exp < now;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
};
